export default "__VITE_ASSET__CMs48LS___"